// ======================================================================
// File Name       : InputInformationDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Modal, Col } from 'react-bootstrap';
import RenderField from '../utils/ReduxFormUtils'

class InputInformationDialog extends React.Component {
    render() {
        const style = {
            background: 'none',
            width: 'auto',
            marginLeft: 0,
            left: 0,
        };
        return (
            <Modal
                className="modal-container"
                show={this.props.showModal}
                size={this.props.mdSize}
                animation={this.props.animation}
                style={style}
            >
                {
                    this.props.title &&
                    <Modal.Header>
                        <Modal.Title className="text-center">
                            {this.props.title}
                        </Modal.Title>
                    </Modal.Header>
                }
                <Modal.Body className="text-center">
                    <Col sm={12}>
                        {this.props.content}
                    </Col>
                    <Col sm={12} className="margin-top-10">
                        <RenderField
                            type="textarea"
                            name="denialReason"
                            // START #5611
                            readOnly
                            rows={9}
                            // START #END
                        />
                    </Col>
                </Modal.Body>

                <Modal.Footer className="text-center">
                    <Button className=" margin-right-10 btn-96" variant="primary" onClick={this.props.onOK}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

InputInformationDialog.defaultProps = { animation: true };
export default InputInformationDialog;
